import React from 'react';
import { PlusIcon } from 'lucide-react';
import { Eyebrow } from '../Eyebrow';
export function ContentFaq({
  faqs
}: {
  faqs: {
    question: string;
    answer: string;
  }[];
}) {
  if (!faqs.length) return null;
  return <section aria-labelledby="page-faq-heading" className="border-t border-line bg-paper-deep py-14 md:py-20" data-id="element-160" data-mp="3dzcapv3bfr5i">
    <div className="mx-auto grid max-w-[1320px] gap-8 px-5 sm:px-8 lg:grid-cols-12 lg:gap-16 lg:px-12" data-id="element-161" data-mp="39yin72tsced5">
      <div className="lg:col-span-4" data-id="element-162" data-mp="2m8og71w5dk0t"><Eyebrow data-id="element-163" data-mp="2m5si9dkauvcd">Useful answers</Eyebrow><h2 id="page-faq-heading" className="mt-5 font-display text-[40px] font-bold uppercase leading-none md:text-[48px]" data-id="element-164" data-mp="2h91xicxjvbkm">Before you get started.</h2></div>
      <div className="min-w-0 border-t border-line lg:col-span-8" data-id="element-165" data-mp="2v1hx13r8srgs">
        {faqs.map((faq, index) => <details key={faq.question} className="group border-b border-line" data-content-faq data-id="element-166" data-mp="2q86ydpwl3gzy" data-mpi={index}>
          <summary className="flex min-h-[64px] cursor-pointer list-none items-center justify-between gap-5 py-5 text-[18px] font-semibold leading-snug marker:content-none [&::-webkit-details-marker]:hidden" data-id="element-167" data-mp="22icnvezqm4iv">
            {faq.question}<PlusIcon aria-hidden="true" className="h-5 w-5 shrink-0 text-steel transition-transform group-open:rotate-45 group-open:text-brand" data-id="element-168" data-mp="xr5g8gzprhoq" />
          </summary>
          <p id={`content-faq-${index}`} className="max-w-[46rem] pb-7 pr-5 text-[16px] leading-relaxed text-steel md:text-[17px]" data-id="element-169" data-mp="17k48c8uf5qd3">{faq.answer}</p>
        </details>)}
      </div>
    </div>
  </section>;
}